<script setup lang="ts">
import defaultBg from '@/assets/image/default-bg.jpg'
const props = defineProps({
  isModal: { type: Boolean },
  domain: null
})
const emits = defineEmits(['close'])
const { t } = useI18n()
const route = useRoute()
const userInfo: any = ref()
const loading = ref(false)
const list = [
  "Full access to this user's content",
  'Direct message with this user',
  'Cancel your subscription at any time',
]
const close = () => {
  emits('close')
}
const profileInfo = async () => {
  try {
    loading.value = true
    const res = await baseService.profileInfo({
      addressOrDomain: props?.domain || route.params?.domain,
    })
    userInfo.value = res
  } catch (error) {
    console.error(error)
  } finally {
    loading.value = false
  }
}
onMounted(() => {
  if (props?.domain || route.params?.domain) {
    loading.value = true
    profileInfo()
  }
})
</script>

<template>
  <div :class="`max-w-172 rounded-3 h-max relative ${isModal ? 'modal-content' : ''}`">
    <div v-if="loading" class="h-146 w-172 flex items-center justify-center">
      <DLoading />
    </div>
    <div v-if="!loading">
      <div
        v-if="userInfo"
        class="flex items-center h-14 typeface-robotoMedium px-4 text-lg sm:text-base"
      >
        {{ t('Global.LogInTo').toLocaleUpperCase() }}
      </div>
      <div
        :class="`flex pb-5 flex-col sm:flex-row ${userInfo?.name ? 'px-4' : 'px-6 sm:pt-0 pt-3'}`"
      >
        <div v-if="userInfo" class="sm:w-78 w-full h-max mr-8 df-b b rounded-2 overflow-hidden">
          <DefaultImg
            :src="userInfo?.background || defaultBg"
            img-type="default"
            class="w-full object-cover h-24"
          />
          <div class="w-full px-4 -mt-12">
            <div class="w-full flex items-end">
              <DefaultImg
                :src="userInfo?.pic"
                img-type="default"
                class="w-24 h-24 rounded-1/2 b b-white dark:b-black rounded-1/2"
              />
              <div class="ml-3">
                <div class="flex items-center">
                  <div class="max-w-35 ellipsis-1 text-base typeface-robotoMedium textHover">
                    {{ userInfo?.userName }}
                  </div>
                  <VipIcon
                    :user-sign-type="userInfo?.userSignType"
                    :domain="userInfo?.creatorDomain"
                    class-name="w-5 ml-1"
                  />
                </div>
                <div v-if="userInfo?.creatorDomain" class="text-brandB text-sm">
                  @{{ userInfo?.creatorDomain }}
                </div>
              </div>
            </div>
          </div>
          <div class="px-4 py-3.5">
            <div class="typeface-robotoMedium text-3.75 leading-6 text-brandB">
              {{ t('Global.GET_BENEFITS') }}:
            </div>
            <div v-for="item in list" :key="item" class="flex items-center mt-2">
              <div i-carbon:checkmark class="text-base icon-bg-right mr-2" />
              <div class="text-sm">
                {{ item }}
              </div>
            </div>
          </div>
        </div>
        <div :class="`sm:w-78 ${userInfo ? '' : 'mt-6'}`">
          <img
            v-if="isDark"
            src="@/assets/newLogo/Logo_full_brand_color.webp"
            :class="`${isModal ? 'mb-5' : 'mb-8'} h-11 mx-auto`"
            alt="dfans"
          />
          <img
            v-else
            src="@/assets/newLogo/Logo_full_brand_color_1.webp"
            :class="`${isModal ? 'mb-5' : 'mb-8'} h-11 mx-auto`"
            alt="dfans"
          />
          <SigninAndSignup :is-modal="isModal" />
        </div>
      </div>
      <div
        class="flex h-12 items-center justify-end text-sm typeface-robotoMedium b-t df-b pr-2"
        @click="close"
      >
        <div
          class="cursor-pointer w-max h-10 flex items-center justify-center rounded-full px-3 hover:bg-white hover:bg-op-8"
          @click="close"
        >
          <span class="font-bg">{{ t('Btn.CLOSE') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
